import { RefObject, useEffect } from 'react';

function scrollToSelectedElement(container: ParentNode | null) {
  if (!container) return;

  const selected = container.querySelector('[data-selected="true"]');

  if (!(selected instanceof HTMLElement)) return;

  let scrollParent: HTMLElement | null = selected.parentElement;

  while (scrollParent && container.contains(scrollParent)) {
    const { overflowY } = getComputedStyle(scrollParent);
    const canScrollY =
      (overflowY === 'auto' || overflowY === 'scroll') &&
      scrollParent.scrollHeight > scrollParent.clientHeight;

    if (canScrollY) {
      const parentRect = scrollParent.getBoundingClientRect();
      const selectedRect = selected.getBoundingClientRect();

      scrollParent.scrollTop +=
        selectedRect.top -
        parentRect.top -
        (parentRect.height - selectedRect.height) / 2;

      return;
    }

    scrollParent = scrollParent.parentElement;
  }
}

export function useScrollToSelectedOnOpen(
  isContentReady: boolean,
  containerRef: RefObject<ParentNode | null>
) {
  useEffect(() => {
    if (!isContentReady) return;

    const frameId = requestAnimationFrame(() => {
      scrollToSelectedElement(containerRef.current);
    });

    return () => cancelAnimationFrame(frameId);
  }, [isContentReady, containerRef]);
}
